// A request that got no answer at all: offline, or a network that blocks havun.nl
// (Henk's work wifi, 22-10-2026). Then the fingerprint or the code was never the problem.
export function geenVerbinding(err) {
  return Boolean(err?.isAxiosError && !err.response);
}

export const GEEN_VERBINDING =
  'Geen verbinding met HavunCore. Blokkeert dit netwerk havun.nl? Probeer mobiele data.';
